import React, { Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const PinSchedulingSettings = lazy(() =>
  import(
    /* webpackChunkName: "PinSchedulingSettings" */ "../components/Scheduling/PostSchedulingSettings"
  )
);
const PinScheduleList = lazy(() =>
  import(
    /* webpackChunkName: "PinScheduleList" */ "../components/Scheduling/PostScheduleList"
  )
);

const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const SchedulingMarketingPage = lazy(() =>
  import(
    /* webpackChunkName: "SchedulingMarketingPage" */ "../components/Scheduling/SchedulingMarketingPage"
  )
);

// Mui stuff
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    maxWidth: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  subTitle: {
    padding: "0px 30px 0px 30px",
    textAlign: "center",
    fontSize: 20,
    paddingBottom: theme.spacing(1),
  },
  schedulingDiv: {
    padding: 20,
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    minWidth: 300,
  },
  editSettingsDiv: {
    display: "flex",

    justifyContent: "center",
    paddingBottom: 20,
  },
}));

function scheduling(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Scheduling & Smart Automation - Content Generator`}
        description={`Optimize your Pinterest strategy with our intelligent scheduling tool. Automatically post posts at optimal times, maintain consistent posting frequency, and maximize engagement with smart scheduling algorithms.`}
        url={`https://contentgenerator.io/scheduling`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <div className={classes.schedulingDiv}>
            <div className={classes.header}>
              <Typography variant="h1">Social Media Scheduler</Typography>
              <Typography className={classes.subTitle}>
                Manage your social media scheduling settings and scheduled posts
                here.
              </Typography>
            </div>
            {props.user.authenticated ? (
              <Fragment>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <PinScheduleList />
                    </Paper>
                  </Grid>
                </Grid>
              </Fragment>
            ) : (
              <Fragment>
                <LoginOrSignup
                  usePaperBackground={false}
                  titleText={"Login or sign up to edit scheduling settings."}
                />
                <SchedulingMarketingPage />
              </Fragment>
            )}
          </div>
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps)(scheduling);
